import { useSitecoreContext } from './useSitecoreContext';

export const useIsEditor = () => {
  const { pageEditing } = useSitecoreContext();
  return pageEditing;
};
